import script from "./LabelerWithAddons.vue?vue&type=script&setup=true&lang=js"
export * from "./LabelerWithAddons.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c820ebe"]])

export default __exports__